import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    url: String,
    categoryId: String,
    colspan: { type: Number, default: 1 }
  }

  initialize() {
    this.prefetchedHTML = null
    this.prefetching = false
  }

  toggle(event) {
    event.preventDefault()

    if (this.isExpanded()) {
      this.collapse()
      return
    }

    this.collapseOthers()
    this.expand()
  }

  preload() {
    if (this.prefetchedHTML || this.prefetching) return
    this.prefetching = true

    fetch(this.urlValue, { credentials: "same-origin", headers: { Accept: "text/html" } })
      .then(response => response.ok ? response.text() : null)
      .then(html => {
        if (!html) return
        const parser = new DOMParser()
        const doc = parser.parseFromString(html, "text/html")
        const frame = doc.querySelector(`turbo-frame#cash-flow-drilldown-${this.categoryIdValue}`)
        this.prefetchedHTML = frame ? frame.innerHTML : null
      })
      .catch(() => {})
      .finally(() => {
        this.prefetching = false
      })
  }

  isExpanded() {
    return this.element.classList.contains("is-expanded")
  }

  expand() {
    this.element.classList.add("is-expanded")
    const row = this.row()
    if (!row) return

    const host = document.createElement("tr")
    host.classList.add("cash-flow-expand-row-host")
    host.dataset.cashFlowDrilldownHost = this.categoryIdValue
    const td = document.createElement("td")
    td.colSpan = this.colspanValue
    const frame = document.createElement("turbo-frame")
    frame.id = `cash-flow-drilldown-${this.categoryIdValue}`

    if (this.prefetchedHTML) {
      frame.innerHTML = this.prefetchedHTML
    } else {
      host.dataset.loading = "true"
      frame.innerHTML = this.skeletonHTML()
      frame.setAttribute("src", this.urlValue)
      frame.addEventListener("turbo:frame-load", () => {
        host.removeAttribute("data-loading")
      }, { once: true })
    }

    td.appendChild(frame)
    host.appendChild(td)
    row.insertAdjacentElement("afterend", host)
  }

  skeletonHTML() {
    return `
      <section class="cash-flow-expand cash-flow-expand-skeleton" aria-busy="true">
        <header class="cash-flow-expand-header">
          <span class="skeleton-bar skeleton-bar-title"></span>
          <span class="skeleton-bar skeleton-bar-scope"></span>
        </header>
        <ul class="cash-flow-expand-list">
          <li class="cash-flow-expand-row"><span class="skeleton-bar skeleton-bar-row"></span></li>
          <li class="cash-flow-expand-row"><span class="skeleton-bar skeleton-bar-row"></span></li>
          <li class="cash-flow-expand-row"><span class="skeleton-bar skeleton-bar-row"></span></li>
        </ul>
      </section>
    `
  }

  collapse() {
    this.element.classList.remove("is-expanded")
    const row = this.row()
    const host = row?.nextElementSibling
    if (host && host.classList.contains("cash-flow-expand-row-host")) {
      host.remove()
    }
  }

  collapseOthers() {
    document.querySelectorAll(".cash-flow-amount.is-expanded").forEach(cell => {
      cell.classList.remove("is-expanded")
    })
    document.querySelectorAll(".cash-flow-expand-row-host").forEach(host => host.remove())
  }

  row() {
    return this.element.closest("tr.cash-flow-row-category")
  }
}
